import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { DownloadIcon } from "~/components/icons/16/DownloadIcon";
import { env } from "~/env";
import styles from "./CorrectionsBlok.module.css";

type Props = ComponentProps<"a"> & {
	filename: string;
	iconOnly?: boolean;
};

export const CorrectionDownload = ({ className, filename, iconOnly, ...props }: Props) => {
	return (
		<a
			className={clsx(
				styles.downloadButton,
				iconOnly && styles.icon,
				"transparent",
				"small",
				className,
			)}
			type="button"
			href={`${env.NEXT_PUBLIC_R2_PUBLIC_URL}/rettelser/${filename}`}
			target="_blank"
			download
			{...props}
		>
			<DownloadIcon stroke="currentColor" /> {!iconOnly && <span>Last ned</span>}
		</a>
	);
};
